module.exports = __webpack_public_path__ + "static/media/400154_01.0bb79eaa.png";